import { Directive, Input, TemplateRef, ViewContainerRef, ComponentFactoryResolver, OnInit, OnChanges, AfterViewInit } from '@angular/core';
import { DVFormGroup, DVFormArray } from '../dynamic-validator';
import { FormarrayContainerComponent } from '../formarray-container/formarray-container.component';

@Directive({
  selector: '[dvFormArrayDef]'
})
export class FormarrayDefDirective implements OnInit {
  @Input('dvFormArrayDef') arrayName: string;
  @Input('dvFormArrayDefFrom') parentForm: DVFormGroup;


  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private cfr: ComponentFactoryResolver,
  ) { }

  ngOnInit() {
    this.viewContainerRef.clear();
    const factory = this.cfr.resolveComponentFactory(FormarrayContainerComponent);
    const componentRef = this.viewContainerRef.createComponent(factory);
    componentRef.instance.formArray = this.parentForm.get(this.arrayName) as DVFormArray;
    componentRef.instance.formTemplate = this.templateRef;
    componentRef.instance.formArrayName = this.arrayName;
    // this.viewContainerRef.createEmbeddedView(this.templateRef)
  }

  // ngOnChanges() {
  //   this.ngOnInit();
  // }
}
